import {
  IonButton,
  IonCard,
  IonCardContent,

  IonSpinner,
} from '@ionic/react';
import { GoPencil } from 'react-icons/go';
import { close } from 'ionicons/icons';
import { useContext, useEffect, useRef, useState } from 'react';
import { DeviceContext } from '../../deviceType';
import { storeSchema } from '../../types/store';
import classes from './styles.module.scss';
import ErrorToast from '../error_toast';
import { useHistory } from 'react-router';
import EditStore from './editStore';
import GenericActionModal from '../genericActionModal';
import { FaLocationDot } from 'react-icons/fa6';
import { IoCall } from 'react-icons/io5';
import { IoIosMail } from 'react-icons/io';
import { RiWhatsappFill } from 'react-icons/ri';
import { formatPhoneNumber } from '../../utils/contacts';

const StoreInfoCard = ({
  store,
  action,
}: {
  store: storeSchema;
  action: () => void;
}) => {
  const size = useContext<any>(DeviceContext);
  const modal = useRef<any>();
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();
  const [_store, setStore] = useState<
    Omit<storeSchema, 'location' | 'type' | 'phoneNumber'> & {
      locations: string[];
      types: string[];
      contacts: string[];
    }
  >(
    {} as Omit<storeSchema, 'location' | 'type' | 'phoneNumber'> & {
      locations: string[];
      types: string[];
      contacts: string[];
    }
  );
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    if (store.id) {
      const { location, type, phoneNumber, ...rest } = store;
      setStore({
        ...rest,
        locations: location!?.split(',')!,
        contacts: phoneNumber?.split(',')!,
        types: type?.split(',')!,
      });
    }
  }, [store]);

  return (
    <IonCard
      className={classes._card + ' w-full h-fit rounded-3xl p-2 m-0 border-0'}
    >
      <ErrorToast
        message={errorMessage}
        type={'error'}
        isOpen={isErrorOpen}
        onClose={() => {
          setIsErrorOpen(false);
        }}
      />
      <GenericActionModal
        open={open}
        title="Edit Store"
        trigger="open-edit-modal"
        height={size.width >= 768 ? '85dvh' : '100dvh'}
        width={size.width >= 768 ? '50dvw' : '100dvw'}
      >
        <div className=" w-full h-[90dvh] md:h-[72dvh] overflow-y-scroll md:px-6 px-4 py-2">
          <EditStore
            close={() => {
              setOpen(false);
            }}
            store={store}
          />
        </div>
      </GenericActionModal>
      {loading && (
        <div className={classes.loading}>
          <IonSpinner name="circles" color={'secondary'}></IonSpinner>
        </div>
      )}

      <IonCardContent className={'size-full relative p-0'}>
        <div className="size-full relative p-0">
          <div className="w-full flex justify-end md:w-fit h-fit ml-[auto]">
            <IonButton
              fill="clear"
              color="secondary"
              id="open-edit-modal"
              size="small"
              className=" text-sm"
              style={{
                '--border-radius': '0',
                '--inline-padding-start': '0',
                'inline-padding-end': '0',
              }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <GoPencil className="mx-1 text-base" />
              Edit
            </IonButton>
          </div>
          <div
            className={
              'w-full h-auto flex flex-row items-center justify-start md:px-4 px-0 md:pt-4'
            }
          >
            <div
              className={
                'h-auto w-[30dvw] md:w-[10dvw] aspect-square rounded-full overflow-hidden bg-gradient-to-br from-[#a94064] to-[#ffc0cb] border-2 border-primary '
              }
            >
              {store?.logo && (
                <img
                  className={'size-full relative object-cover object-center'}
                  alt="Store Profile"
                  src={store?.logo!}
                />
              )}
            </div>
            <div className="w-auto h-auto flex flex-col  md:mt-6  ml-4">
              <div className=" w-auto font-semibold text-xl text-primary font-roboto">
                {_store?.name}
              </div>
              {/* <div
                className=" w-auto font-medium text-sm cursor-pointer text-secondary md:mb-2"
                onClick={() => history.push(`/${_store?.slug}`)}
              >
                @{_store?.slug}
              </div> */}
              <div className="w-full md:w-auto h-auto flex flex-row items-center flex-wrap">
                <div className="w-[15px] md:w-[18px] h-auto aspect-square flex items-center justify-center mr-2">
                  <FaLocationDot size="100%" className="text-secondary" />
                </div>
                {store.location?.split(',')!.map((item, index) => (
                  <div
                    key={index}
                    className="w-fit h-fit flex flex-row items-center justify-between pr-[2px]"
                  >
                    <div className="w-fit text-sm  text-primary cursor-pointer ">
                      {item},
                    </div>
                  </div>
                ))}
              </div>
              {store.whatsappContact && (
                <div className="w-full h-fit flex flex-row items-center pb-2 mt-1 ">
                  <div className="w-[18px] h-auto aspect-square flex items-center justify-center mr-2">
                    <RiWhatsappFill size="100%" className="text-green-600" />
                  </div>

                  <div className="w-fit text-[var(--ion-color-primary)] text-sm">
                    {formatPhoneNumber('+'+store.whatsappContact)}
                  </div>
                </div>
              )}
              <div
                className={
                  'w-full h-fit text-sm flex flex-col items-start'
                }
              >
                {store.phoneNumber?.split(',')!.map((item, index) => (
                  <div
                    key={index}
                    className="w-full h-fit flex flex-row items-center pb-2 "
                  >
                    <div className="w-[18px] h-auto aspect-square flex items-center justify-center mr-2">
                      {index === 0 && (
                        <IoCall size="100%" className="text-secondary" />
                      )}
                    </div>

                    <div className="w-fit text-[var(--ion-color-primary)]">
                     {formatPhoneNumber('+'+item)}
                    </div>
                  </div>
                ))}
                <div className="w-full h-fit flex flex-row items-center pb-2 ">
                  <div className="w-[18px] h-auto aspect-square flex items-center justify-center mr-2">
                    <IoIosMail size="100%" className="text-secondary" />
                  </div>

                  <div className="w-fit text-[var(--ion-color-primary)]">
                    {store.email}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full h-auto pt-4 px-4 flex flex-col items-center">
            <div
              className={
                classes._description +
                ' pb-2 w-full h-fit font-normal md:text-base text-primary'
              }
            >
              <div>{_store?.description}</div>
            </div>

            <div className="w-full  h-auto flex flex-row items-center flex-wrap">
              {store.type?.split(',')!.map((item, index) => (
                <span
                  className="bg-red-100 text-secondary text-xs rounded-full m-1 px-2 py-1"
                  key={index}
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </IonCardContent>
    </IonCard>
  );
};

export default StoreInfoCard;
